var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "artist"
  }, [_c('div', {
    staticClass: "artist-heading"
  }, [_c('h2', [_c('span', {
    staticClass: "artist-name"
  }, [_vm._v(_vm._s(_vm.artist.name))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "artist-length"
  }, [_vm._v(_vm._s(_vm.artist.work))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "artist-location"
  }, [_vm._v(_vm._s(_vm.artist.about))]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.artist.href,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.artist.site))])])]), _vm._v(" "), _c('div', {
    staticClass: "artist-detail"
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": '/static/img/' + _vm.artist.image
    }
  })]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.artist.copy)
    }
  })])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4edaef98","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExhibitPage/ExhibitItem.vue
// module id = 13pN
// module chunks = 1